import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { getDriver } from '../../../drivers/data/datasources/get-driver';

export const addDriverToHub = async (
  promisor_id: string,
  contract_id: string,
  driver_id: string,
  hub_id: string
): Promise<any> => {
  await lpRequest(`/fleet/${clientId()}/drivers/${driver_id}/hubs`, {
    method: 'POST',
    body: { promisor_id, hub_id }
  });

  return getDriver(driver_id);
};
